<template>
  <v-text-field
    v-model="modelFilter"
    dense
    clearable
    single-line
    hide-details="true"
    :type="fieldType"
    class="mt-0"
    autocapitalize="off"
    autocomplete="off"
    autocorrect="off"
    spellcheck="false"
    @click:clear.prevent="clear"
  >
    <template #prepend-inner>
      <v-menu
        offset-y
        :close-on-content-click="true"
      >
        <template #activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on">
            <v-icon v-text="icon"></v-icon>
          </span>
        </template>
        <v-list dense>
          <v-list-item-group
            v-model="modelType"
            color="primary"
          >
            <v-list-item
              v-for="(item, k) in listData[fieldType]"
              :key="k"
              :value="item.key"
              @click.prevent="icon = item.icon"
            >
              <v-list-item-icon class="mr-2">
                <v-icon small v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.text"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
    </template>
  </v-text-field>
</template>

<script lang="ts">
import Vue from 'vue';
import intl from '@/utils/intl';

export default Vue.extend({
  name: 'FilterInputType',
  props: {
    type: String
  },
  data() {
    return {
      icon: 'mdi-magnify',
      fieldType: this.type,
      modelFilter: null,
      modelType: 'c',
      listData: {
        text: [
          { key: 'c', icon: 'mdi-format-underline-wavy', text: intl.t('dataTableFilters.c') },
          { key: 'nc', icon: 'mdi-format-strikethrough-variant', text: intl.t('dataTableFilters.nc') },
          { key: 'sw', icon: 'mdi-contain-start', text: intl.t('dataTableFilters.sw') },
          { key: 'ew', icon: 'mdi-contain-end', text: intl.t('dataTableFilters.ew') },
          { key: 'eq', icon: 'mdi-equal', text: intl.t('dataTableFilters.eq') },
          { key: 'neq', icon: 'mdi-not-equal-variant', text: intl.t('dataTableFilters.neq') }
        ],
        number: [
          { key: 'c', icon: 'mdi-format-underline-wavy', text: intl.t('dataTableFilters.c') },
          { key: 'eq', icon: 'mdi-equal', text: intl.t('dataTableFilters.eq') },
          { key: 'lt', icon: 'mdi-less-than', text: intl.t('dataTableFilters.lt') },
          { key: 'gt', icon: 'mdi-greater-than', text: intl.t('dataTableFilters.gt') },
          { key: 'lte', icon: 'mdi-less-than-or-equal', text: intl.t('dataTableFilters.lte') },
          { key: 'gte', icon: 'mdi-greater-than-or-equal', text: intl.t('dataTableFilters.gte') }
        ]
      }
    }
  },
  watch: {
    modelFilter(val) {
      this.$emit('filterValueChange', val);
    },
    modelType(val) {
      this.$emit('typeChange', val);
    }
  },
  methods: {
    clear() {
      this.icon = 'mdi-magnify';
      this.modelType = 'c';
      this.modelFilter = null;
    }
  }
});
</script>
